<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{
              labelBtn != "Salvar"
                ? "Editar Campanha Status"
                : "Cadastrar Campanha Status"
            }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="6">
              <v-text-field
                label="Status"
                v-model="formStatus.status"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? editarStatus() : cadastrarStatus()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/inputRules";
import campanha from "@/services/http/campanhaService";

export default {
  name: "ModalCadStatus",

  mixins: [rules],
  components: {},

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    statusCampanha: {
      type: Object
    }
  },

  data() {
    return {
      formStatus: {},
      items: []
    };
  },

  watch: {
    statusCampanha() {
      if (this.statusCampanha) {
        this.formStatus = this.statusCampanha;
      }
    }
  },

  methods: {
    async cadastrarStatus() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await campanha()
          .status()
          .store(this.formStatus, {
            notification: true,
            message: "Status Campanha cadastrado com sucesso!"
          }),
          this.close();
      }
    },

    async editarStatus() {
      const validateStatus = this.$refs.form.validate();
      if (validateStatus) {
        await campanha()
          .status(this.formStatus.id_status)
          .update(this.formStatus, {
            notification: true,
            message: "Status Campanha editado com sucesso!"
          }),
          this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
